// Client+server safe helpers for CMS data. No Payload/Next-server imports
// here — importing from this file is guaranteed not to pull server-only
// modules (db adapters, sharp, etc.) into a client bundle.

import { optimizeCloudinaryUrl } from '@/lib/videoConfig'

export function titleToSlug(title: string): string {
  return String(title || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function formatJobTitle(title: string): string {
  return String(title || '')
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase())
}

// Extract a media URL from the common shapes our CMS layer emits. After the
// Payload migration most media objects are flat (`{ url, alt, sizes }`), but
// we keep the legacy response shapes so mixed payloads during transition don't
// break the UI.
export function getCmsMediaUrl(media: unknown): string | null {
  if (!media) return null
  if (typeof media === 'string') return media
  if (typeof media !== 'object') return null

  const m = media as Record<string, unknown>
  if (typeof m.url === 'string') return m.url

  const urlFromData = (m as { data?: { attributes?: { url?: unknown } } })?.data?.attributes?.url
  if (typeof urlFromData === 'string') return urlFromData

  const arrData = (m as { data?: unknown }).data
  if (Array.isArray(arrData)) {
    const first = (arrData as Array<{ attributes?: { url?: unknown } }>)[0]
    const nested = first?.attributes?.url
    if (typeof nested === 'string') return nested
  }

  return null
}

export function getCmsImageUrl(media: unknown): string | null {
  const raw = getCmsMediaUrl(media)
  if (!raw) return null
  return optimizeCloudinaryUrl(raw, false)
}
